import { Button } from '@/components/ui/button.tsx';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx';
import { Ellipsis } from 'lucide-react';
import { TPlantPDFReport } from '@/features/dashboard/components/admin/energy-report.tsx';
import React, { Suspense } from 'react';
import { lazyWithPreload } from '@/utils/lazy-with-preload.ts';
import { Skeleton } from '@/components/ui/skeleton.tsx';
import { cn } from '@/utils/utils.ts';
import PerformanceMonitoringExportCSV from '@/features/dashboard/components/admin/performance-monitoring-export-csv.tsx';

const PerformanceMonitoringExportPDF = lazyWithPreload(
  () => import('@/features/dashboard/components/admin/performance-monitoring-export-pdf.tsx')
);

export const PerformanceMonitoringOptions = ({
  startDate,
  currentViewContext,
  getPlantReport,
}: {
  startDate: Date;
  currentViewContext: 'all' | string;
  getPlantReport: () => TPlantPDFReport | undefined;
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <DropdownMenu open={open} onOpenChange={() => setOpen((o) => !o)}>
      <DropdownMenuTrigger asChild>
        <Button
          disabled={currentViewContext === 'all'}
          variant="secondary"
          className={cn('p-2', currentViewContext !== 'all' && 'cursor-pointer')}
        >
          <Ellipsis />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <Suspense
          fallback={
            <div className="flex min-h-8 min-w-[136px] items-center gap-2 px-2 py-1.5">
              <Skeleton className="size-4 rounded" />
              <Skeleton className="h-4 w-24" />
            </div>
          }
        >
          <PerformanceMonitoringExportPDF
            getPlantReport={getPlantReport}
            startDate={startDate}
          >
            {({ onClick, icon, text }) => (
              <DropdownMenuItem onClick={onClick} className="min-w-[136px] gap-2">
                {icon}
                {text}
              </DropdownMenuItem>
            )}
          </PerformanceMonitoringExportPDF>
        </Suspense>
        <PerformanceMonitoringExportCSV getPlantReport={getPlantReport} startDate={startDate}>
          {({ onClick, icon, text }) => (
            <DropdownMenuItem onClick={onClick} className="min-w-[136px] gap-2">
              {icon}
              {text}
            </DropdownMenuItem>
          )}
        </PerformanceMonitoringExportCSV>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default PerformanceMonitoringOptions;
